export const hasValue = (value: any): boolean => {
  if (value === null || value === undefined) return false;
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'string') return value.trim() !== '';
  if (typeof value === 'number') return !Number.isNaN(value);
  if (typeof value === 'object') return Object.keys(value).length > 0;
  if (typeof value === 'boolean') return true;
  return true;
};

export const isTextValue = (value: unknown): boolean =>
  typeof value === 'string' ||
  typeof value === 'number' ||
  (Array.isArray(value) && value.every(entry => typeof entry === 'string' || typeof entry === 'number'));

export const deepClone = (value: any) => {
  if (typeof structuredClone === 'function') {
    return structuredClone(value);
  }
  return JSON.parse(JSON.stringify(value));
};

export const isNullOrUndefined = (value: any): boolean => value === null || value === undefined;
